export function rgbArray2css(rgbaArray) {
    if (hasOpacity(rgbaArray)) {
        return rgbaArray2rgba(rgbaArray);
    }
    return "#" + rgbaArray2hex(rgbaArray);
}
export function rgbArray2hybridCSS(rgbaArray) {
    var value = "#" + rgbaArray2hex(rgbaArray);
    if (hasOpacity(rgbaArray)) {
        var opacityPct = Math.round(rgbaArray[3] * 100);
        value += " - " + opacityPct + "%";
    }
    return value;
}
export function rgbaArray2rgba(rgbaArray) {
    var rgbValues = rgbaArray.slice(0, 3).map(function (v) { return Math.round(v * 255); });
    if (hasOpacity(rgbaArray)) {
        rgbValues.push(rgbaArray[3]);
        return "rgba(" + rgbValues.join(', ') + ")";
    }
    return "rgb(" + rgbValues.join(', ') + ")";
}
export function rgbaArray2rgbaCSS(rgbaArray) {
    var rgbValues = rgbaArray.slice(0, 3).map(function (v) { return Math.round(v * 255); });
    var opacity = rgbaArray[3];
    var opacityValue = Number.isInteger(opacity) ? opacity : opacity.toFixed(2);
    return "rgba(" + rgbValues.join(', ') + ", " + opacityValue + ")";
}
export function hasOpacity(rgbaArray) {
    return rgbaArray[3] < 1;
}
export function rgbaArray2hex(rgbaArray) {
    return rgbaArray
        .slice(0, 3)
        .map(function (v) { return paddedHex(Math.round(v * 255)); })
        .join('')
        .toUpperCase();
}
function paddedHex(hexValue) {
    var leftPad = '';
    if (hexValue < 16) {
        leftPad = '0';
    }
    return "" + leftPad + hexValue.toString(16);
}
export function colourIsDark(rgbaArray) {
    /* eslint-disable no-bitwise */
    var rgb = parseInt(rgbaArray2hex(rgbaArray), 16);
    var r = (rgb >> 16) & 0xff; // extract red
    var g = (rgb >> 8) & 0xff; // extract green
    var b = (rgb >> 0) & 0xff; // extract blue
    var luma = 0.213 * (r / 255) + 0.715 * (g / 255) + 0.072 * (b / 255);
    var opacity = rgbaArray[3];
    return luma < 0.5 || opacity < 0.5;
    // returns true is luma is below 0.5, meaning it's a dark colour
}
export function rgbToHsl(r, g, b) {
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h;
    var s;
    var l = (max + min) / 2;
    if (max === min) {
        h = 0;
        s = 0;
    }
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            default:
                break;
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return [h * 8, s * 8, l * 8];
}
